"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KvadratVPCComponentSerializer = exports.KvadratVPCComponent = void 0;
var CoreToolboxComponentIds_1 = require("../CoreToolboxComponentIds");
/**
 * KvadratVPCComponent is a component for holding the VPC code of a Kvadrat room.
 * The purpose is to hold the Kvadrat VPC code when the scene is saved, so that it can be restored when
 * the solution is read.
 *
 * For Core to be able to deserialize this component, you need to register the {@link KvadratVPCComponentSerializer}.
 */
var KvadratVPCComponent = /** @class */ (function () {
    function KvadratVPCComponent(vpc) {
        this.typeId = KvadratVPCComponent.id;
        this.doStoreInSnapshot = false;
        this.serializable = true;
        this.vpc = vpc;
    }
    KvadratVPCComponent.prototype.serializationKey = function () {
        return KvadratVPCComponent.KEY;
    };
    KvadratVPCComponent.prototype.toJson = function (parse) {
        return parse(JSON.stringify(this.vpc));
    };
    KvadratVPCComponent.prototype.eq = function (_other) {
        return _other instanceof KvadratVPCComponent && _other.vpc === this.vpc;
    };
    KvadratVPCComponent.id = CoreToolboxComponentIds_1.CoreToolboxComponentIds.KvadratVPCComponentId;
    KvadratVPCComponent.KEY = 'kvadrat_vpc_code';
    return KvadratVPCComponent;
}());
exports.KvadratVPCComponent = KvadratVPCComponent;
/**
 * THe KvadratVPCComponentSerializer is needed if you want to deserialize the {@link KvadratVPCComponent}.
 * Register it with the `Core.services.componentSerializerRegistry`.
 */
var KvadratVPCComponentSerializer = /** @class */ (function () {
    function KvadratVPCComponentSerializer() {
        this.thisClassIsGuaranteedToNotModifyOrQueryCoreState = true;
    }
    KvadratVPCComponentSerializer.prototype.canHandle = function (serializationKey) {
        return serializationKey == KvadratVPCComponent.KEY;
    };
    KvadratVPCComponentSerializer.prototype.deserialize = function (serializationKey, json) {
        if (serializationKey == KvadratVPCComponent.KEY) {
            var vpc = JSON.parse(json.toString());
            return new KvadratVPCComponent(vpc);
        }
        return null;
    };
    return KvadratVPCComponentSerializer;
}());
exports.KvadratVPCComponentSerializer = KvadratVPCComponentSerializer;
//# sourceMappingURL=KvadratVPCComponent.js.map